import React from 'react';
import styled from 'styled-components';
import { MAX_MOBILE_WIDTH_IN_PX } from '../constants';
import { HeadShakeAnimation } from '../../../styles/HeadShakeAnimation';
export const DIAMETER_AVATAR_IN_REM_DESKTOP = 4.5;
const DIAMETER_AVATAR_IN_REM_MOBILE = 3.5;
const AvatarWrapper = styled.span `
  display: block;
  position: relative;
  height: ${DIAMETER_AVATAR_IN_REM_DESKTOP}rem;
  width: ${DIAMETER_AVATAR_IN_REM_DESKTOP}rem;
  z-index: 1;

  @media screen and (max-width: ${MAX_MOBILE_WIDTH_IN_PX}px) {
    height: ${DIAMETER_AVATAR_IN_REM_MOBILE}rem;
    width: ${DIAMETER_AVATAR_IN_REM_MOBILE}rem;
  }

  /* Avatar shadow */
  &::after {
    background: ${props => props.theme.GrayLighter};
    border-radius: 50%;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0.25rem;
    width: 100%;
    z-index: -1;
  }

  &:hover {
    animation: ${HeadShakeAnimation} 2s;

    @media screen and (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`;
const Image = styled.img `
  border-radius: 50%;
  height: 100%;
  width: 100%;
`;
export const Avatar = ({ alt, className, src, }) => (React.createElement(AvatarWrapper, { className: className },
    React.createElement(Image, { alt: alt, src: src })));
